import React from 'react';

// Exemple VISUEL d'une vente qui arrive + ce que le chatteur doit faire.
// Réutilisé dans DropFans → Attribution ET dans le guide (tour Inbox, étape « Ventes »).
// compact=true → version étroite empilée (pour le popover du guide, ~400px).
export default function SaleAttributionExample({ compact = false }) {
  const Notif = (
    <div>
      <div className="text-[11px] uppercase tracking-wider text-slate-500 mb-2">Un paiement arrive → 1 clic</div>
      <div className="rounded-xl border border-white/10 bg-white/[0.03] p-3">
        <div className="flex items-center gap-2 mb-1">
          <span className="text-amber-400">💸</span>
          <span className="text-sm font-medium text-white">Vente à rattacher</span>
          <span className="ml-auto text-sm font-semibold text-white">75 €</span>
        </div>
        <div className="text-[11px] text-slate-500 mb-2">Chloé · owen.r…@gmail.com · PayPal</div>
        <div className="flex items-center gap-2 rounded-lg bg-indigo-500/15 px-2.5 py-1.5">
          <span className="w-7 h-7 rounded-full bg-white/10 flex items-center justify-center text-[11px] font-bold text-indigo-200">O</span>
          <span className="text-[13px] text-indigo-100">C'est Owen, 24 ans ?</span>
        </div>
        <div className="flex gap-2 mt-2">
          <span className="flex-1 text-center text-xs py-1.5 rounded-lg bg-emerald-500/15 text-emerald-300 border border-emerald-500/30">✓ Oui, c'est lui</span>
          <span className="flex-1 text-center text-xs py-1.5 rounded-lg bg-white/5 text-slate-300 border border-white/10">Autre fan</span>
        </div>
        <div className="text-[11px] text-emerald-300/80 mt-2">→ rattaché + signé → ses prochains paiements = automatiques</div>
      </div>
    </div>
  );

  const Statuts = (
    <div>
      <div className="text-[11px] uppercase tracking-wider text-slate-500 mb-2">Statuts d'un script (partagés entre chatteurs)</div>
      <div className="rounded-xl border border-white/10 bg-white/[0.03] p-3 space-y-2 text-[13px]">
        <div className="flex items-center gap-2"><span className="w-2.5 h-2.5 rounded-full bg-slate-600 shrink-0" /> <span className="text-slate-400">Rien envoyé</span></div>
        <div className="flex items-center gap-2"><span className="w-2.5 h-2.5 rounded-full bg-amber-400 shrink-0" /> <span className="text-slate-200">Partiel <span className="text-slate-500">— quelques médias vus (3/5)</span></span></div>
        <div className="flex items-center gap-2"><span className="w-2.5 h-2.5 rounded-full bg-slate-500 shrink-0" /> <span className="text-slate-500"><span className="line-through">Déjà envoyé</span> (tous les médias)</span></div>
        <div className="flex items-center gap-2"><span className="text-emerald-400 shrink-0">✓</span> <span className="text-emerald-300">Payé</span></div>
      </div>
    </div>
  );

  if (compact) {
    return (
      <div className="space-y-3">
        {Notif}
        <div className="text-[12px] text-slate-300 leading-relaxed rounded-lg bg-white/[0.03] border border-white/10 p-2.5">
          <span className="text-white font-medium">Ce que tu fais :</span> la 1ʳᵉ fois qu'un nouveau fan paie (DropFans <span className="text-white">ou PayPal</span>),
          tu cliques <span className="text-emerald-300">« Oui, c'est lui »</span>. C'est tout — ensuite ses paiements se rattachent <span className="text-white">tout seuls</span>.
        </div>
        {Statuts}
      </div>
    );
  }

  return (
    <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-5">
      <div className="text-sm font-semibold text-white mb-3">Exemple visuel</div>
      <div className="grid md:grid-cols-2 gap-4">{Notif}{Statuts}</div>
    </div>
  );
}
